import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { SharedModule } from '../shared/shared.module';
import { ClaimAccountRoutingModule } from './claim-account-routing.module';
import { ClaimAccountComponent } from './claim-account.component';
import { ClaimAccountService } from './claim-account.service';

@NgModule({
  imports: [NgSelectModule, SharedModule, ClaimAccountRoutingModule],
  declarations: [ClaimAccountComponent],
  providers: [ClaimAccountService],
  exports: [],
})
export class ClaimAccountModule { }
